import { useAuroraIncomingHandlers } from 'shared-ui/aurora'

import { useAuroraControlsContext } from '../auroraControls/auroraControlsStore'
import { useAuroraClientDispatchHandlers } from './useAuroraClientDispatchHandlers'

/**
 * Registers the web client's handlers for server-initiated Aurora
 * messages (dispatched tools, pushes). Renders nothing — it just owns the
 * handler lifecycle.
 *
 * PoC scope: AgentNotification renders via `window.alert`. Future iterations
 * will swap in a toast / notification panel rather than a blocking modal.
 */
const AuroraClientHandlers: React.FC = () => {
  const dispatch = useAuroraClientDispatchHandlers()
  useAuroraControlsContext()

  useAuroraIncomingHandlers({
    dispatch,
    push: {
      AgentNotification: ({ text }) => {
        window.alert(text)
      }
    }
  })

  return null
}

export default AuroraClientHandlers
